import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar.jsx'
import Footer from './components/Footer.jsx'
import Home from './pages/Home.jsx'
import Portfolio from './pages/Portfolio.jsx'
import Projects from './pages/Projects.jsx'
import Team from './pages/Team.jsx'
import Contact from './pages/Contact.jsx'

function App() {
  return (
    <Router>
      <div data-component-path="client/src/App.jsx" data-component-line="1:1" data-component-id="client/src/App.jsx:1:1" className="min-h-screen bg-stone-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App